'use client'

import type React from 'react'

import { useIntl } from 'react-intl'

import { FormattedMessage, Link } from '@b-stock/fe-core/bstock-react'

import { Body, List, ListItem, SectionHeader } from './ui'

const ATT_POLICY_DOCUMENT_URLS = {
  conditionGuidelines:
    'https://docserv.bstock.com/v1/documents/69c17e9efb67e8963073be9b',
  unlockingTerms:
    'https://docserv.bstock.com/v1/documents/69a8ee23bdc8a5ccc632e314',
} as const

const ns = 'AttPolicyPoints'

export const AttPolicyPoints = ({
  termsDisplayName,
  termsDocUrl,
}: {
  termsDisplayName: string
  termsDocUrl: string
}) => {
  const { formatMessage } = useIntl()
  const conditionGuidelinesText = formatMessage({
    id: `${ns}.conditionGuidelines`,
  })
  const unlockingTermsText = formatMessage({ id: `${ns}.unlockingTerms` })

  return (
    <Body>
      <SectionHeader>
        <FormattedMessage id={`${ns}.reviewHeader`} />
      </SectionHeader>
      <List>
        <ListItem>
          <FormattedMessage id={`${ns}.paymentCollectedByAtt`} />
        </ListItem>
        <ListItem>
          <FormattedMessage id={`${ns}.accountKeySent`} />
        </ListItem>
        <ListItem>
          <FormattedMessage id={`${ns}.separateServiceFee`} />
        </ListItem>
        <ListItem>
          <FormattedMessage id={`${ns}.ordersProcessed`} />
        </ListItem>
      </List>

      <SectionHeader>
        <FormattedMessage id={`${ns}.agreeHeader`} />
      </SectionHeader>
      <List>
        <ListItem>
          <FormattedMessage
            id={`${ns}.agreeToLinks`}
            values={{
              termsLink: (chunks: React.ReactNode) => (
                <Link target="_blank" href={termsDocUrl}>
                  {chunks}
                </Link>
              ),
              termsName: termsDisplayName,
              conditionGuidelinesLink: (chunks: React.ReactNode) => (
                <Link
                  target="_blank"
                  href={ATT_POLICY_DOCUMENT_URLS.conditionGuidelines}
                >
                  {chunks}
                </Link>
              ),
              conditionGuidelinesText,
              unlockingTermsLink: (chunks: React.ReactNode) => (
                <Link
                  target="_blank"
                  href={ATT_POLICY_DOCUMENT_URLS.unlockingTerms}
                >
                  {chunks}
                </Link>
              ),
              unlockingTermsText,
            }}
          />
        </ListItem>
        <ListItem>
          <FormattedMessage id={`${ns}.devicesDataWiped`} />
        </ListItem>
        <ListItem>
          <FormattedMessage id={`${ns}.ordersShipUS`} />
        </ListItem>
        <ListItem>
          <FormattedMessage id={`${ns}.noRmasCredits`} />
        </ListItem>
      </List>
    </Body>
  )
}
